import React, { useState } from "react";
import clsx from "clsx";

import overlayImg from "static/images/overlayTrigger.png";
import styles from "./overlayTrigger.module.scss";

const OverlayTrigger = ({
	title,
	tooltipClassName = "",
	wrapperClassName = "",
	overlayIcon = overlayImg,
}) => {
	const [isShowText, setIsShowText] = useState(false);
	return (
		<div className={clsx(styles.wrappTrigger, wrapperClassName)}>
			{isShowText && (
				<div className={clsx(styles.tooltip, tooltipClassName)}>
					{title}
					<div className={styles.triangle}></div>
				</div>
			)}
			<img
				className={styles.overlayImg}
				src={overlayIcon}
				onMouseEnter={() => setIsShowText(!isShowText)}
				onMouseLeave={() => setIsShowText(!isShowText)}
				alt="Overlay"
			/>
		</div>
	);
};

export default OverlayTrigger;
